module.exports = __webpack_public_path__ + "img/pose-fs-9.0761ec1f.png";